module.exports = __webpack_public_path__ + "img/1480768730.132b4136.jpg";